var findAncestor = function(el, cls) {
  while (!el.classList.contains(cls)) {
    el = el.parentNode;
    if(!el || !el.classList){
      el = null;
      break;
    }
  }
  return el;
}

export default findAncestor;